import { filterPlan } from "QuotePage/PlanFilters";
import { createSelector } from "reselect";
import _ from "underscore";

import type { State } from "QuotePage/Store";
import type { DentalPlan } from "Utils/types";

export const getAllDentalPlans = (state: State) => state.allDentalPlans || [];

export const isLoadingDentalPlans = (state: State) => state.isLoadingAllDentalPlans;

export function getDentalFilterConfig(state: State) {
  const { dentalFilter, ..._rest } = state.filters;
  return dentalFilter;
}

export const getFilteredDentalPlansRoutine = (filterConfig: unknown, plans: DentalPlan[]) => {
  const sortOrder = "average_monthly_premium";
  // Shallow Copy plans array
  const plansCopy = plans.slice();

  // Filter
  const filteredPlans = _.chain(plansCopy).filter(_.partial(filterPlan, filterConfig)).value();

  // Sort
  const visiblePlans = _.chain(filteredPlans)
    .sortBy(_.partial(_.getPath, _, sortOrder))
    .value();

  return Object.freeze(visiblePlans);
};

export const getFilteredDentalPlans = createSelector([getDentalFilterConfig, getAllDentalPlans], getFilteredDentalPlansRoutine);

export const getRecommendedVisibleDentalPlans = (state: State) => getFilteredDentalPlans(state).filter((plan) => plan.recommended === true);

export const getOtherVisibleDentalPlans = (state: State) => getFilteredDentalPlans(state).filter((plan) => plan.recommended === false);
